/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SwipeableList, Type as ListType } from 'react-swipeable-list';
import { AddInvoice, DenominationFooter } from 'components/pages/collection';
import { NoData } from 'components';
import { Box } from 'atoms';
import { InvoiceSwipeWrapper } from 'components/pages/collection/swipe-invoices/InvoiceCardWrapper';

const Cards = styled(Box)`
	max-height: 75vh;
	padding-bottom: 2rem;
	overflow: auto;
`;

export default function MyCollections() {
	const { invoices = [], filteredInvoices = [] } = useSelector((state) => state.invoice);

	return (
		<>
			{invoices?.length === 0 ? (
				<>
					<NoData>Invoice Not Available</NoData>
					<AddInvoice />
				</>
			) : (
				<Cards>
					{filteredInvoices?.length > 0 ? (
						<>
							<SwipeableList fullSwipe={false} threshold={0.25} type={ListType.IOS}>
								{filteredInvoices?.map((invoice) => (
									<InvoiceSwipeWrapper key={invoice?.id} invoice={invoice} />
								))}
							</SwipeableList>
							<AddInvoice />
						</>
					) : (
						<NoData>Invoice Not Found</NoData>
					)}

					<DenominationFooter />
				</Cards>
			)}
		</>
	);
}
